<template>
  <div>
    <template v-if="selectedFlag">
      <shipblu-button id="restart-btn-loading" size="small" :textButton="$t('Recreate')" :iconStyle="{iconPosition:'left', LeftIconName: 'RotateCwIcon', LeftIconLibrary: 'feather'}" @click="restartOrders()" class="vs-con-loading__container w-full"/>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select canceled orders')}`">
        <shipblu-button size="small" :textButton="$t('Recreate')" :iconStyle="{iconPosition:'left', LeftIconName: 'RotateCwIcon', LeftIconLibrary: 'feather'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
import {sendRequest} from '../../../http/axios/requestHelper.js'
export default {
  props: ['selected'],
  data () {
    return {
      selectedFlag: false
    }
  },
  watch: {
    selected (val) {
      if (val.length > 0 && val.length === val.filter(item => !item.fulfillment_provider_metadata && item.status === 'cancelled').length) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
    }
  },
  methods: {
    restartOrders () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#restart-btn-loading',
        scale: 0.45
      })
      const orders = []
      this.selected.forEach(element => {
        if (element.status === 'cancelled') {
          orders.push(element.id)
        }
      })
      sendRequest(true, false, this, 'api/v1/orders/restart-cancelled/', 'post', {orders_id: orders}, true,
        () => {
          this.$emit('loadShipments')
          this.$emit('selected', [])
          this.$vs.loading.close('#restart-btn-loading > .con-vs-loading')
        }
      )
    }
  }
}
</script>